import React from 'react';
import posterPDF from '../images/poster.pdf';

const largeDivStyle = {
  padding: "60px",
  alignContent: "center"
};

const Poster = () => {
  return (
    <div style={largeDivStyle}>
        <object 
            width="1000"
            height="1040"
            type="application/pdf"
            data={posterPDF}
            vspace="10"
        />
    </div>
  );
};

export default Poster;